import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllUser = async ()=>{
    const response = await axios.get(buildApiUrl('user/getUserList/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllUser = data;

    console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllUser;
};


const setActiveUser = async (id,val)=>{
    const response = await axios.post(buildApiUrl('user/setUserActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUser = data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',response);


    return AllUser;
};



const setDeletedUser = async (id,val)=>{
    const response = await axios.post(buildApiUrl('user/setDeletedUser/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUser = data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',response);


    return AllUser;
};




const setUpdateUser = async (dataUserUpdate)=>{
    const response = await axios.post(buildApiUrl('user/setUserUpdate/'),{
        "dataUpdate":dataUserUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllUser = response.data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',dataUserUpdate,response);


    return AllUser;
};


const setSaveNewUser = async (dataUpdate)=>{
    const response = await axios.post(buildApiUrl('user/setNewUser/'),{
        dataUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllUser =  response.data;

    // console.log('Сервер вернул данные по обновлению статуса User  - ',response, dataUserUpdate);


    return AllUser;
};

Mock.onGet('/api/user/getUserList').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllUser = await getAllUser();
    console.log('С сервера пришло - ', AllUser);

    // if (!AllUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllUser,
    ]


})


Mock.onPost('/api/user/setActiveUser').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllUser = await setActiveUser(id,val);

    // if (!AllUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllUser,
    ]


})

Mock.onPost('/api/user/setDeletedUser').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllUser = await setDeletedUser(id,val);

    // if (!AllUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllUser,
    ]


})


Mock.onPost('/api/user/setUpdateUser').reply(async (config) => {
    let { dataUserUpdate } = JSON.parse(config.data);

    const User = await setUpdateUser(dataUserUpdate);
    const {error, errorInfo, result, message, data } = User;

    if (!User) {
        return [400, {userList:[],result:User.result}]
    }


    return [
        200,
        {userList:data,result:result,error:error,errorInfo:errorInfo},
    ]


})


Mock.onPost('/api/user/setNewUser').reply(async (config) => {
    let { dataUserUpdate } = JSON.parse(config.data);
    const User = await setSaveNewUser(dataUserUpdate);
    const {error, errorInfo, result, message, data } = User;

    if (!User) {
        return [400, {userList:[],result:result,error:error,errorInfo:errorInfo,message:message}]
    }


    return [
        200,
        {userList:data,result:result,error:error,errorInfo:errorInfo,message:message},
    ]
})